import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const link = document.createElement("link");
link.href = "https://fonts.googleapis.com/css2?family=Caprasimo&display=swap";
link.rel = "stylesheet";
document.head.appendChild(link);

root.render(
  <React.StrictMode>
    <BrowserRouter basename="">
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
